import reportWebVitals, { sendToGoogleAnalytics } from './reportWebVitals';
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const container = document.getElementById('root');

// Use hydration if the page was pre-rendered by react-snap
if (container.hasChildNodes()) {
  hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Send Web Vitals to Google Analytics 4
reportWebVitals(sendToGoogleAnalytics);
